import router from './router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { Notification } from 'element-ui'
import { Route } from 'vue-router'
import { UserModule } from '@/store/modules/user'
import { PermissionModule } from '@/store/modules/permission'
import i18n from '@/lang' // Internationalization
import settings from './settings'

NProgress.configure({ showSpinner: false })

const whiteList = ['/login', '/auth-redirect']

const getPageTitle = (key: string) => {
  const hasKey = i18n.te(`route.${key}`)
  if (hasKey) {
    const pageName = i18n.t(`route.${key}`)
    return `${pageName} - ${settings.title}`
  }
  return `${settings.title}`
}

router.beforeEach(async(to: Route, _: Route, next: any) => {
  // Start progress bar
  NProgress.start()

  let nextRoute = to.path === '/login' ? undefined : to.query.redirect
  let replace = false

  const authorizationCode = to.query.code

  if (authorizationCode) {
    await UserModule.SigninRedirectCallback()

    nextRoute = '/'
    replace = true
  }

  await UserModule.GetUser()

  // Determine whether the user has logged in
  if (UserModule.user) {
    if (to.path === '/login') {
      nextRoute = '/'
      NProgress.done()
    } else if (!PermissionModule.routesGenerated) {
      await UserModule.GetUserInfo()
      const roles = UserModule.roles
      // Generate accessible routes map based on role
      PermissionModule.GenerateRoutes(roles)
      // Dynamically add accessible routes
      PermissionModule.dynamicRoutes.forEach(route => {
        router.addRoute(route)
      })

      next(to.path)
    }
  } else {
    const toPath = (nextRoute || to.path).toString()
    if (whiteList.indexOf(toPath) == -1) {
      nextRoute = `/login?redirect=${encodeURIComponent(to.fullPath)}`
    }
  }

  next({ path: nextRoute, replace: replace })
})

router.afterEach((to: Route) => {
  // Finish progress bar
  // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
  NProgress.done()

  // set page title
  document.title = getPageTitle(to?.meta?.title)
})
